export default "__VITE_ASSET__BN790Q93__"